<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
          :data="tbWorkPermitDataList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="企业编码" align="center" prop="companyCode"/>
        <el-table-column label="作业报备编号" align="center" prop="tbWorkPermitReport.reportCode"/>
        <el-table-column label="作业开始时间" align="center" prop="startTime">
          <template slot-scope="{ row }">
            <span v-if="row.startTime">{{ row.startTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="作业结束时间" align="center" prop="endTime">
<!--          <template slot-scope="{ row }">
            <span v-if="row.endTime">{{ row.endTime | timeFilter }}</span>
          </template>-->
        </el-table-column>
        <el-table-column label="是否承包商作业" align="center" prop="isContractorWork">
          <template slot-scope="{ row }" slot="isContractorWork">
            <Tag v-if="row.isContractorWork===1" >是</Tag>
            <Tag v-if="row.isContractorWork===0" >否</Tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="isUpload">
          <template slot-scope="{ row }">
            <Tag v-if="row.isUpload===1" color="success">已上报</Tag>
            <Tag v-if="row.isUpload===0" color="warning">未上报</Tag>
          </template>
        </el-table-column>
        <!--        <el-table-column
                    label="负责人"
                    align="center">
                  <template slot-scope="{ row }">
                    {{ getEmployeeName(row.employeeId) }}
                  </template>
                </el-table-column>-->
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>

    <!-- 添加或修改管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="作业票报备信息编号" prop="activityReportId">
          <el-select v-model="form.activityReportId" placeholder="请选择作业票报备信息编号">
            <el-option
                v-for="dict in tbWorkPermitReportList"
                :key="dict.reportId"
                :label="dict.reportCode"
                :value="dict.reportId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作业类型" prop="ticketType">
          <el-select v-model="form.ticketType" placeholder="请选择作业类型" style="width: 100%">
            <el-option-group
                v-for="group in ticketTypeList"
                :key="group.label"
                :label="group.label">
              <el-option v-for="item in group.options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"/>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="施工单位" prop="workDepartment">
          <el-input v-model="form.workDepartment" placeholder="请输入施工单位"/>
        </el-form-item>
        <el-form-item label="是否承包商作业" prop="isContractorWork">
          <el-select v-model="form.isContractorWork" style="width: 100%">
            <el-option :value="1" label="是"/>
            <el-option :value="0" label="否"/>
          </el-select>
        </el-form-item>
        <!--  <el-form-item label="是否被引用" prop="reference">
          <el-select v-model="form.reference" style="width: 100%">
            <el-option :value="1" label="是"/>
            <el-option :value="0" label="否"/>
          </el-select>
        </el-form-item>
      <el-form-item label="被引用的作业票编号" prop="ticketId">
          <el-select v-model="form.activityReportId" placeholder="当引用选择是时请选择引用的作业票编号">
            <el-option
                v-for="dict in tbWorkPermitReportList"
                :key="dict.reportId"
                :label="dict.reportCode"
                :value="dict.reportId"></el-option>
          </el-select>
        </el-form-item>-->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import {
  listTbWorkPermitData,
  getTbWorkPermitData,
  addTbWorkPermitData,
  updateTbWorkPermitData,
  delTbWorkPermitData
} from '@/api/baseDate/TbWorkPermitData';
import {listTbWorkPermitReport} from '@/api/baseDate/TbWorkPermitReport';

export default {
  name: "TbWorkPermitData",
  data() {
    return {
      tbWorkPermitDataList: [],
      tbWorkPermitReportList: [],
      ticketTypeList: [
        {
          label: "动火作业",
          value: "0",
          options: [
            {label: "特级动火作业", value: "01"},
            {label: "一级动火作业", value: "02"},
            {label: "二级动火作业", value: "03"},
          ]
        },
        {
          label: "临时用电作业",
          value: "1",
          options: [
            {label: "临时用电作业", value: "10"},
          ]
        },
        {
          label: "高处作业",
          value: "2",
          options: [
            {label: "I级高处作业", value: "21"},
            {label: "II级高处作业", value: "22"},
            {label: "III级高处作业", value: "23"},
            {label: "IV级高处作业", value: "24"},
          ]
        },
        {
          label: "动土作业",
          value: "3",
          options: [
            {label: "动土作业", value: "30"},
          ]
        },
        {
          label: "断路作业",
          value: "4",
          options: [
            {label: "断路作业", value: "40"},
          ]
        },
        {
          label: "盲板抽堵作业",
          value: "5",
          options: [
            {label: "盲板抽堵作业", value: "50"},
          ]
        },
        {
          label: "吊装作业",
          value: "6",
          options: [
            {label: "一级吊装作业", value: "61"},
            {label: "二级吊装作业", value: "62"},
            {label: "三级吊装作业", value: "63"},
          ]
        },
        {
          label: "受限空间作业",
          value: "7",
          options: [
            {label: "受限空间作业", value: "70"},
          ]
        },
        {
          label: "倒罐作业",
          value: "A",
          options: [
            {label: "倒罐作业", value: "A0"},
          ]
        },
        {
          label: "清罐作业",
          value: "B",
          options: [
            {label: "清罐作业", value: "B0"},
          ]
        },
        {
          label: "切水作业",
          value: "C",
          options: [
            {label: "切水作业", value: "C0"},
          ]
        }
      ],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null,
    }
  },
  created() {
    this.getTbWorkPermitDataList();
    this.getTbWorkPermitReportList();
  },
  methods: {
    getTbWorkPermitDataList() {
      listTbWorkPermitData({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.tbWorkPermitDataList = res.body.data
        this.total = res.body.cum
      })
    },
    getTbWorkPermitReportList() {
      listTbWorkPermitReport().then(res => {
        this.tbWorkPermitReportList = res.body.data
      })
    },
    handleType(type) {
      let list = this.riskLevelArr.filter(item => item.value === type)
      return list[0].label
    },
    pageChange(val) {
      this.curPage = val;
      this.getTbWorkPermitDataList();
    },
    addBtn() {
      this.reset()
      this.open = true
      this.title = '添加宝山园区特殊作业活动备案信息'

    },
    editBtn(row) {
      this.reset()
      const id = row.id
      getTbWorkPermitData(id).then(response => {
        this.form = response.body.data
        this.open = true
        this.title = '修改宝山园区特殊作业活动备案信息'
      })
    },
    deleteBtn(row) {
      delTbWorkPermitData(row.id).then(res => {
        this.$message.success('删除成功')
        this.getTbWorkPermitDataList()
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        companyCode: null,
        activityReportId: null,
        startTime: null,
        endTime: null,
        ticketType: null,
        ticketPosition: null,
        jobContent: null,
        supervisorName: null,
        workerName: null,
        personId: null,
        workDepartment: null,
        socialCreditCode: null,
        isContractorWork: null,
        ticketResponsName: null,
        majorPersonMobile: null,
        reference: null,
        ticketId: null,
        deleted: null,
        createDate: null,
        createBy: null,
        updateDate: null,
        updateBy: null
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateTbWorkPermitData(this.form).then(response => {
              this.open = false
              this.$message.success('修改成功')
              this.getTbWorkPermitDataList()
            })
          } else {
            addTbWorkPermitData(this.form).then(response => {
              this.open = false
              this.$message.success('新增成功')
              this.getTbWorkPermitDataList()
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>
